/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import RaisedButton from 'material-ui/RaisedButton'

import { TextField, AutoComplete } from 'generic/form'
import * as actions from 'actions/User'
import * as constants from 'constants/User'

import 'resources/styles/interpreter/Profile.css'

class ProfilePage extends Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      password: undefined,
      password_confirm: undefined,
      user: undefined,
      errors: {}
    }
  }

  getFieldErrorObject (errors) {
    let errorObject = {}
    errors.forEach((error) => {
      errorObject[error.field_name] = error.errors[0].user_message
    })

    return errorObject
  }

  handleChange (event, value) {
    const name = event.target.name

    this.setState({
      [name]: value
    })
  }

  handleSubmit (e) {
    e.preventDefault()
    if (this.state.password.localeCompare(this.state.password_confirm) !== 0) {
      this.setState({
        errors: {
          password_confirm: this.props.intl.formatMessage(constants.messages.PASSWORD_MISMATCH)
        }
      })

      return
    }

    actions.updatePassword(this.state.user, this.state.password)
      .then((result) => {
        this.setState({
          confirmationMessage: this.props.intl.formatMessage(constants.messages.CONFIRMATION_MESSAGE),
          errors: {}
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          const fieldErrors = this.getFieldErrorObject(error.response.data.field_errors)
          this.setState({
            errors: fieldErrors
          })
        }
      })
  }

  handleReturn () {
    this.props.history.push({pathname: '/dashboard/'})
  }

  updateAutocompleteUser (name, value) {
    this.setState({'user': value})
  }

  transformUser (user) {
    return {
      ...user,
      display: user.username
    }
  }

  render () {
    return (
      <div className='interpreter profile-container'>
        <div className='profile-title'>
          {
            this.props.intl.formatMessage(constants.messages.TITLE)
          }
        </div>
        <div className='form-container'>
          <form onSubmit={this.handleSubmit}>
            { this.props.location.showUserName
              ? <AutoComplete
                name='user'
                textKey='display'
                valueKey='uid'
                searchKey='text'
                searchText={this.state.user ? this.state.user.username : undefined}
                popoverProps={{style: {width: 400}}}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.USER_LABEL)}
                url={actions.USER_LIST_URL}
                transformData={this.transformUser}
                updateItem={this.updateAutocompleteUser}
                disabled={this.state.confirmationMessage}
              />
              : undefined
            }
            <TextField
              name='password'
              type='password'
              value={this.state.password}
              disabled={this.state.confirmationMessage}
              onChange={this.handleChange}
              fullWidth
              floatingLabelText={this.props.intl.formatMessage(constants.messages.PASSWORD_LABEL)}
              errorText={this.state.errors.password}
            />
            <div className='second-input'>
              <TextField
                name='password_confirm'
                type='password'
                value={this.state.password_confirm}
                disabled={this.state.confirmationMessage}
                onChange={this.handleChange}
                fullWidth
                floatingLabelText={this.props.intl.formatMessage(constants.messages.CONFIRM_LABEL)}
                errorText={this.state.errors.password_confirm}
              />
            </div>
            <div className='button-container'>
              { !this.state.confirmationMessage
                ? <RaisedButton
                  style={{margin: 10}}
                  disabled={this.props.location.showUserName ? !this.state.password || !this.state.password_confirm || !this.state.user : !this.state.password || !this.state.password_confirm}
                  label={ this.props.intl.formatMessage(constants.messages.SUBMIT_LABEL) }
                  primary={true}
                  type="submit"
                />
                : undefined
              }
              <RaisedButton
                style={{margin: 10}}
                label={ this.props.intl.formatMessage(constants.messages.BACK_LABEL) }
                secondary={true}
                onClick={this.handleReturn}
              />
            </div>
          </form>
          <div className='confirmation-message'>
            { this.state.confirmationMessage }
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(injectIntl(ProfilePage))



// WEBPACK FOOTER //
// ./src/components/pages/ProfilePage.js